exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-5b12e06e]{position:relative;clear:both;width:100%;height:100%}p[data-v-5b12e06e]{color:#fff}", ""]);

// exports
